export const DASHBOARDS_PAGE_KEY = 'analytics-hub-admin-dashboards' as const;
